// hooks/useInfiniteMessages.js
import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../config/apiConfig";
import { getRegisterId } from "../utils/authId";
import { getSelectedDms, getSelectedPerson } from "../utils/auth";
export const useInfiniteMessagesHome = (searchQuery = "") => {
  const regId = getRegisterId();
  const limit = 20; // or whatever your limit is
  const selected = getSelectedPerson();
  const fetchMessages = async ({ pageParam = 1 }) => {
    const response = await api.get(
      `api/get_single_chat_details_pagination/${selected?.chat_unique}?register_id=${regId}&page=${pageParam}&per_page=${limit}&search=${searchQuery}`,
      {}
    );

    return {
      messages: response.data.messages || [],
      pagination: response.data.pagination,
      nextPage: pageParam + 1,
      hasMore: pageParam < (response.data.pagination?.total_pages || 0),
    };
  };

  return useInfiniteQuery({
    queryKey: ["messages", selected?.chat_unique, searchQuery],
    queryFn: fetchMessages,
    getNextPageParam: (lastPage) => {
      return lastPage.hasMore ? lastPage.nextPage : undefined;
    },
    enabled: !!selected?.chat_unique,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes
  });
};

export const useInfiniteMessagesDms = (searchQuery = "") => {
  const regId = getRegisterId();
  const limit = 20; // or whatever your limit is
  const selected = getSelectedDms();

  const fetchMessages = async ({ pageParam = 1 }) => {
    const response = await api.get(
      `api/get_single_chat_details_pagination/${selected?.chat_unique}?register_id=${regId}&page=${pageParam}&per_page=${limit}&search=${searchQuery}`,
      {}
    );

    return {
      messages: response.data.messages || [],
      pagination: response.data.pagination,
      nextPage: pageParam + 1,
      hasMore: pageParam < (response.data.pagination?.total_pages || 0),
    };
  };

  return useInfiniteQuery({
    queryKey: ["messages", selected?.chat_unique, searchQuery],
    queryFn: fetchMessages,
    getNextPageParam: (lastPage) => {
      return lastPage.hasMore ? lastPage.nextPage : undefined;
    },
    enabled: !!selected?.chat_unique,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes
  });
};
